import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../app/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_38aa0644 from 'nuxt_plugin_sentryserver_38aa0644' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_7df18b56 from 'nuxt_plugin_sentryclient_7df18b56' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_markdownit_79d3b8b8 from 'nuxt_plugin_markdownit_79d3b8b8' // Source: ./markdownit.js (mode: 'all')
import nuxt_plugin_axios_71a611cc from 'nuxt_plugin_axios_71a611cc' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../app/plugins/axios (mode: 'all')
import nuxt_plugin_vuelidate_4345260a from 'nuxt_plugin_vuelidate_4345260a' // Source: ../app/plugins/vuelidate (mode: 'all')
import nuxt_plugin_vetable_0711a4a6 from 'nuxt_plugin_vetable_0711a4a6' // Source: ../app/plugins/ve-table (mode: 'client')
import nuxt_plugin_gtm_63eb8124 from 'nuxt_plugin_gtm_63eb8124' // Source: ../app/plugins/gtm.js (mode: 'client')
import nuxt_plugin_vuetagsinput_eb545e9a from 'nuxt_plugin_vuetagsinput_eb545e9a' // Source: ../app/plugins/vue-tags-input (mode: 'client')
import nuxt_plugin_editor_6bfb673a from 'nuxt_plugin_editor_6bfb673a' // Source: ../app/plugins/editor (mode: 'client')
import nuxt_plugin_lazysizes_63bafee8 from 'nuxt_plugin_lazysizes_63bafee8' // Source: ../app/plugins/lazysizes (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"script":[{"hid":"gop","innerHTML":"window.dataLayer = window.dataLayer || [];","type":"text\u002Fjavascript"},{"src":"\u002F\u002Fcdn.iframe.ly\u002Fembed.js?api_key=9963ba188b11f65863d572&omit_script=1","async":true},{"src":"\u002F\u002Fcdn.jsdelivr.net\u002Fgh\u002Fethereum\u002Fweb3.js@1.0.0-beta.34\u002Fdist\u002Fweb3.min.js","defer":true}],"__dangerouslyDisableSanitizersByTagID":{"gop":["innerHTML"]},"title":"ALIS - ブロックチェーンソーシャルメディア","titleTemplate":"%s | ALIS","meta":[{"charset":"utf-8"},{"hid":"viewport","name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"apple-mobile-web-app-title","content":"ALIS"},{"hid":"description","name":"description","content":"ALISは記事の作成やいいねで人気NFTやトークンがもらえるソーシャルメディアです。はじめてブロックチェーンを利用する方も無料で気軽に楽しめます。"},{"hid":"og:title","property":"og:title","content":"ALIS - ブロックチェーンソーシャルメディア"},{"hid":"og:description","property":"og:description","content":"ALISは記事の作成やいいねで人気NFTやトークンがもらえるソーシャルメディアです。はじめてブロックチェーンを利用する方も無料で気軽に楽しめます。"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Falis.to\u002Fd\u002Fnuxt\u002Fdist\u002FOGP_1200×630.png"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:site","name":"twitter:site","content":"@ALIS_media"},{"hid":"twitter:image","name":"twitter:image","content":"https:\u002F\u002Falis.to\u002Fd\u002Fnuxt\u002Fdist\u002FOGP_1200×630.png"},{"hid":"fb:app_id","property":"fb:app_id","content":"2157199921164241"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"https:\u002F\u002Falis.to\u002Fd\u002Fnuxt\u002Fdist\u002Ffavicon.ico"},{"rel":"apple-touch-icon","sizes":"192x192","href":"https:\u002F\u002Falis.to\u002Fd\u002Fnuxt\u002Fdist\u002Ftouch-icon.png"},{"rel":"shortcut icon","href":"https:\u002F\u002Falis.to\u002Fd\u002Fnuxt\u002Fdist\u002Ftouch-icon.png"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Ffont-awesome\u002F5.9.0\u002Fcss\u002Fall.min.css"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_38aa0644 === 'function') {
    await nuxt_plugin_sentryserver_38aa0644(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_7df18b56 === 'function') {
    await nuxt_plugin_sentryclient_7df18b56(app.context, inject)
  }

  if (typeof nuxt_plugin_markdownit_79d3b8b8 === 'function') {
    await nuxt_plugin_markdownit_79d3b8b8(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_71a611cc === 'function') {
    await nuxt_plugin_axios_71a611cc(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_4345260a === 'function') {
    await nuxt_plugin_vuelidate_4345260a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vetable_0711a4a6 === 'function') {
    await nuxt_plugin_vetable_0711a4a6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_63eb8124 === 'function') {
    await nuxt_plugin_gtm_63eb8124(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetagsinput_eb545e9a === 'function') {
    await nuxt_plugin_vuetagsinput_eb545e9a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_editor_6bfb673a === 'function') {
    await nuxt_plugin_editor_6bfb673a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazysizes_63bafee8 === 'function') {
    await nuxt_plugin_lazysizes_63bafee8(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
